// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YT2PKhAYI6Es4BVGkjYv{background-color:var(--background-primary-inverted-primary);flex-direction:column;width:100%;height:100vh;display:flex}.YT2PKhAYI6Es4BVGkjYv .HpSc_LOCMXQpR7zFHqu4{text-align:center}.nqUFt6QMTQku1iFzeOwq{height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `YT2PKhAYI6Es4BVGkjYv`,
	"subtitle": `HpSc_LOCMXQpR7zFHqu4`,
	"successWrap": `nqUFt6QMTQku1iFzeOwq`
};
export default ___CSS_LOADER_EXPORT___;
